<template>
  <div class="camera-archive-statistics container-with-collapsible-tree-sidebar">
    <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
      <el-tab-pane :lazy="true" label="区域" name="0">
        <!--侧边栏-->
        <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" :diffSize="90" @toggle="toggleTreeSideBar">
          <div class="general-container">
            <el-input class="search-input"
                      v-model="treeNodeFilter"
                      placeholder="请输入区域名称"
                      clearable>
              <img slot="prefix" src="@/assets/img/icon_search.png">
            </el-input>
          </div>
          <el-tree
            class="mt5"
            ref="tree"
            :data="treeData"
            :props="defaultTreeProps"
            node-key="key"
            :default-expanded-keys="treeExpandedKeys"
            :expand-on-click-node="false"
            highlight-current
            :filter-node-method="filterTreeNode"
            @node-click="handleTreeNodeClick"
          >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
          </el-tree>
        </app-tree-side>
        <!--表格数据-->
        <div class="col-2">
          <el-form ref="queryForm" class="pagination-table-query-form" :inline="true"
                   @keyup.enter.native="handleFormQuery()">
            <el-form-item label="统计日期">
              <uni-date-picker
                v-model="date">
              </uni-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleFormQuery()" type="primary">查 询</el-button>
              <el-button @click="resetQueryForm()">重 置</el-button>
            </el-form-item>
          </el-form>
          <el-row>
            <el-col class="chart-container" :span="12">
              <div class="chart-title">各建档数量占比</div>
              <annular-pie
                ref="annularPie"
                :id="pieId"
                :source="pieData"
                :color="pieColor"
                :title="pieTitle"
                :legend="pieLegend"
                style="width:100%; height:300px"
              ></annular-pie>
            </el-col>
            <el-col class="chart-container" :span="12">
              <div class="chart-title">各区域数量对比</div>
              <bar
                ref="bar"
                :id="barId"
                :source="barData"
                :color="barColor"
                style="width:100%; height:300px"
              ></bar>
            </el-col>
          </el-row>
          <div class="pagination-table-container">
            <el-table :data="tableData"
                      ref="table"
                      v-loading="loading"
                      border element-loading-background="rgba(255, 255, 255, 0.8)"
                      element-loading-spinner="el-icon-loading"
                      element-loading-text="努力加载中..."
                      style="width: 100%">
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="区域" prop="regionName" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="接入数" prop="totalCount"></el-table-column>
              <el-table-column label="全部完善数" prop="completedCount"></el-table-column>
              <el-table-column label="未完善数" prop="notStartedCount"></el-table-column>
              <el-table-column label="部分完善数" prop="partiallyCompletedCount"></el-table-column>
              <el-table-column label="基本完善数" prop="basicallyCompletedCount"></el-table-column>
              <el-table-column label="统计日期" prop="statDateTime" width="120">
                <template slot-scope="scope"> {{strDateFromSTime_t(scope.row.statDateTime)}}</template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @current-change="handleCurrentPageChange"
              @size-change="handlePageSizeChange"
              :current-page.sync="tableQueryParams.pageNum"
              :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
              :page-size.sync="tableQueryParams.pageSize"
              prev-text="上一页"
              next-text="下一页"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableTotalRow">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <!--行业-->
      <el-tab-pane :lazy="true" label="行业" name="1">
        <div class="ml5 mt5">
          <el-form ref="queryForm2" class="pagination-table-query-form" :inline="true"
                   @keyup.enter.native="handleFormQuery2()">
            <el-form-item label="行业">
              <el-cascader
                v-model="industryCascaderCheckedNodes"
                :options="industryCascaderOptions"
                :props="defaultCascaderProps"
                :show-all-levels="false"
                collapse-tags
                clearable
                placeholder="请选择行业(默认全部)"
                style="width: 280px"></el-cascader>
            </el-form-item>
            <el-form-item label="统计日期">
              <uni-date-picker
                v-model="date2">
              </uni-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleFormQuery2()" type="primary">查 询</el-button>
              <el-button @click="resetQueryForm2()">重 置</el-button>
            </el-form-item>
          </el-form>
          <el-row>
            <el-col class="chart-container" :span="12">
              <div class="chart-title">各建档数量占比</div>
              <annular-pie
                ref="annularPie2"
                :id="pieId2"
                :source="pieData2"
                :color="pieColor"
                :title="pieTitle"
                :legend="pieLegend"
                style="width:100%; height:300px"
              ></annular-pie>
            </el-col>
            <el-col class="chart-container" :span="12">
              <div class="chart-title">各行业数量对比</div>
              <bar
                ref="bar2"
                :id="barId2"
                :source="barData2"
                :color="barColor"
                style="width:100%; height:300px"
              ></bar>
            </el-col>
          </el-row>
          <div class="pagination-table-container">
            <el-table :data="tableData2"
                      ref="table2"
                      v-loading="loading"
                      border element-loading-background="rgba(255, 255, 255, 0.8)"
                      element-loading-spinner="el-icon-loading"
                      element-loading-text="努力加载中..."
                      style="width: 100%">
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="行业" prop="regionKind" :show-overflow-tooltip="true">
                <template slot-scope="scope"> {{getNameById(scope.row.regionKind,$type.industries)}}</template>
              </el-table-column>
              <el-table-column label="接入数" prop="totalCount"></el-table-column>
              <el-table-column label="全部完善数" prop="completedCount"></el-table-column>
              <el-table-column label="未完善数" prop="notStartedCount"></el-table-column>
              <el-table-column label="部分完善数" prop="partiallyCompletedCount"></el-table-column>
              <el-table-column label="基本完善数" prop="basicallyCompletedCount"></el-table-column>
              <el-table-column label="统计日期" prop="statDateTime" width="120">
                <template slot-scope="scope"> {{strDateFromSTime_t(scope.row.statDateTime)}}</template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @current-change="handleCurrentPageChange"
              @size-change="handlePageSizeChange"
              :current-page.sync="tableQueryParams2.pageNum"
              :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
              :page-size.sync="tableQueryParams2.pageSize"
              prev-text="上一页"
              next-text="下一页"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableTotalRow2">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="text/ecmascript-6">
import CameraArchiveStatistics from './CameraArchiveStatistics.js'
export default CameraArchiveStatistics
</script>

<style lang="scss">
  @import "CameraArchiveStatistics";
</style>



// WEBPACK FOOTER //
// src/views/statistics/cameraArchiveStatistics/CameraArchiveStatistics.vue